import { ButtonLink } from '@design/components/button-link/ButtonLink';
import React from 'react';

import styles from './DrawerSectionFooter.module.scss';

type DrawerSectionFooterProps = {
  label: string;
  onClick: () => void;
};

export const DrawerSectionFooter = ({
  label,
  onClick,
}: DrawerSectionFooterProps) => (
  <ButtonLink
    className={styles.buttonLink}
    label={label}
    iconName={'ChevronLightRight'}
    iconPosition="right"
    onClick={onClick}
  />
);
